// removed by extract-text-webpack-plugin
module.exports = {"messageWrap":"qempo_WeAre_messageWrap-2vJqt1a"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/about-us/components/WeAre/WeAre.scss
// module id = 1169
// module chunks = 0